/**
 * 判断列表项是否属于「首屏」，用来决定图片要不要懒加载。
 *
 * 为什么需要它：信息流列表容器上挂着 v-show="!showSkeleton"，骨架屏期间整块是
 * display:none。浏览器对隐藏容器里 loading="lazy" 的图片是**不发请求**的（不在视口内），
 * 所以如果无脑给所有头像写 lazy，首屏头像会一直等到骨架屏收起（skeletonMixin 有
 * 300ms 最短展示）之后才开始下载，白白慢一截。
 *
 * 首屏的几条改成 eager + fetchpriority=high 立刻下载，其余保持懒加载，
 * 无限滚动到几百条时也不会浪费请求。
 *
 * 宿主组件需要有 index prop（在列表中的下标）。
 */

// 桌面和移动首屏都在 3 条左右，留一点缓冲
const EAGER_COUNT = 6

export default {
  computed: {
    isAboveFold () {
      return (this.index || 0) < EAGER_COUNT
    }
  }
}
